<template>
  <div class="content-form">
    <div class="is-flex">
      <PartnerDetail v-for="(item, index) in relatives" :key="index"
        @click.native="editRelativeData(index)"
        :data="item"
        :index="index"
      />
    </div>

    <PartnerModal v-if="formVisible" 
      :data="relatives[activeRelativeIndex]"
      :index="activeRelativeIndex"
      @close="close"
      @submit="submit" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import PartnerModal from "./PartnerModal";
import PartnerDetail from "./PartnerDetail";


export default {
  components: {
    PartnerDetail,
    PartnerModal
  },
  data() {
    return {
      partnerInfo : {
        name: undefined,
        relationship: undefined,
        phone: undefined,
        year_of_birth: undefined,
        occupation: undefined,  
      },

      relatives: [],
      activeRelativeIndex: undefined
    };
  },  
  computed: {
    ...mapGetters(["formData"]),
    formVisible () {
      return this.activeRelativeIndex >= 0
    }
  },
  methods: {
    editRelativeData (index) {
      this.activeRelativeIndex = index
    },
    close () {
      this.activeRelativeIndex = -1
    },
    submit(index, data) {
      this.relatives[index] = data[index]
    }
  },
  created() {
    const formData = this.formData
    if (formData) {
      formData.relatives.length === 2
      ? this.relatives = formData.relatives
      : this.relatives = [this.partnerInfo, this.partnerInfo]
    }
  },
};
</script>
